/**
 * "Rebuild search index" (PLAN §12.2.3): the palette core registers the
 * command, the local index (builder B) does the work — `rebuild({ part: 'all' })`
 * on this platform's index client (`palette_index_rebuild` on desktop).
 *
 * `busy`: a part is still filling (first backfill or a rebuild already
 * running), so a new rebuild would only restart it. Any other §12.2 code means
 * the index is not usable here. The notice says which; it never fails silently.
 */
import { useNotificationStore } from '../store/notificationStore';
import { getIndexClient } from './index';
import i18n from '../i18n';

export async function rebuildPaletteIndex({ client = getIndexClient() } = {}) {
  const notes = useNotificationStore.getState();
  const say = (key) => notes.info?.(i18n.t(key), i18n.t('palette.notice.title'));
  try {
    await client.rebuild({ part: 'all' });
    say('palette.rebuild.started');
    return true;
  } catch (err) {
    say(err?.code === 'busy' ? 'palette.rebuild.busy' : 'palette.rebuild.unavailable');
    return false;
  }
}
